module.exports = __webpack_public_path__ + "static/skillset-ca6bd50e224f6590aa3a3c468abc4eef.png";